import { FC } from 'react'

import { Grid } from './DetailsGrid.styles'
import { DetailsGridProps } from './DetailsGrid.types'

const DetailsGrid: FC<DetailsGridProps> = ({
    children,
    className,
    dataTestId,
}) => {
    return (
        <Grid className={className} data-testid={dataTestId}>
            {children}
        </Grid>
    )
}

export default DetailsGrid
